import axios from '../../axios'

export const getBlogs = async (params) => {
  try {
    const response = await axios.get('/v1/blogs', {
      params,
    })

    if (response.data.success) {
      return response.data.data
    }
  } catch (error) {
    return false
  }
}

export const getBlog = async (id) => {
  try {
    const response = await axios.get(`/v1/blogs/${id}`)

    if (response.data.success) {
      return response.data.data
    }
  } catch (error) {
    return false
  }
}

export const createBlog = async (blog) => {
  try {
    const response = await axios.post('/v1/blogs', blog)

    if (response.data.success) {
      return response.data.data
    }
  } catch (error) {
    return false
  }
}

export const updateBlog = async (id, blog) => {
  try {
    const response = await axios.put(`/v1/blogs/${id}`, blog)

    if (response.data.success) {
      return response.data.data
    }
  } catch (error) {
    return false
  }
}

export const uploadFile = async (file) => {
  try {
    let data = new FormData()
    data.append('file', file, file.name)

    const response = await axios.post('/v1/cdn/upload', data)
    if (response.data.success) {
      return response.data.data
    }
  } catch (err) {
    console.log(err)
  }
}
